// extracted by mini-css-extract-plugin
export default {"box":"FooterNavbar_box__X1lJl","logo":"FooterNavbar_logo__MlUGV","list":"FooterNavbar_list__wsMPS"};